import React from "react";
import { Typography, Box, Chip } from "@material-ui/core";
import { useDialogStyles } from "../styles/dialogStyles";
import { TFunction } from "i18next";
import { JobStatusColor } from "customHooks/useList/components/FieldsType/FieldJobStatus";
import ButtonIconTooltipCompleo from "Components/ButtonIconTooltipCompleo";
import { Cached } from "@material-ui/icons";
import { useQueryClient } from "react-query";
import { jobApprovalStatusQueryAddress } from "../JobApprovalStatusDialog";

interface DialogHeaderProps {
    jobId: string;
    jobTitle: string;
    jobStatus: CompleoShared.Common.JobStatus;
    currentStage?: number;
    totalStages?: number;
    t: TFunction;
}

export function DialogHeader({
    jobId,
    jobTitle,
    currentStage,
    totalStages,
    jobStatus,
    t
}: DialogHeaderProps) {
    const classes = useDialogStyles();
    const queryClient = useQueryClient();

    return (
        <div className={classes.header}>
            <Typography className={classes.headerTitle}>
                {t("title")}{" "}
                <ButtonIconTooltipCompleo
                    label={t("btnRefresh")}
                    onClick={() => {
                        queryClient.invalidateQueries(
                            jobApprovalStatusQueryAddress
                        );
                        queryClient.invalidateQueries("/job/search");
                        queryClient.invalidateQueries("/job/list");
                        queryClient.invalidateQueries(
                            "/jobrequest/listrequest"
                        );
                    }}
                >
                    <Cached style={{ color: "white" }} />
                </ButtonIconTooltipCompleo>
            </Typography>
            <Typography className={classes.headerSubtitle}>
                {jobTitle} - ({jobId})
                <Chip
                    className={classes.chipCard}
                    style={{
                        backgroundColor: JobStatusColor[jobStatus],
                        color: "white"
                    }}
                    size="small"
                    label={t(`JOBSTATUS_${jobStatus}`)}
                />
                {totalStages && currentStage && (
                    <span style={{ marginLeft: 16, fontWeight: "bold" }}>
                        {t("stageNofN", {
                            stageNumber: currentStage,
                            totalStages
                        })}
                    </span>
                )}
            </Typography>
        </div>
    );
}
